import {
  PDF_TEMPLATE_LIST,
  PDF_TEMPLATE_LIST_SUCCESS,
  PDF_TEMPLATE_LIST_FAILURE,
  PDF_TEMPLATE_RENDER,
  PDF_TEMPLATE_RENDER_SUCCESS,
  PDF_TEMPLATE_RENDER_FAILURE,
  PDF_TEMPLATE_SAVE,
  PDF_TEMPLATE_SAVE_SUCCESS,
  PDF_TEMPLATE_SAVE_FAILURE,
  PDF_TEMPLATE_DELETE,
  PDF_TEMPLATE_DELETE_SUCCESS,
  PDF_TEMPLATE_DELETE_FAILURE,
  PDF_TEMPLATE_DUPLICATE,
  PDF_TEMPLATE_DUPLICATE_SUCCESS,
  PDF_TEMPLATE_DUPLICATE_FAILURE,
  PDF_TEMPLATE_UPLOAD_SOURCE,
  PDF_TEMPLATE_UPLOAD_SOURCE_SUCCESS,
  PDF_TEMPLATE_UPLOAD_SOURCE_FAILURE,
  PDF_TEMPLATE_PREVIEW,
  PDF_TEMPLATE_PREVIEW_SUCCESS,
  PDF_TEMPLATE_PREVIEW_FAILURE,
} from "./actionType";

// List PdfTemplates
export const listPdfTemplates = () => {
  return {
    type: PDF_TEMPLATE_LIST,
  };
};

export const listPdfTemplatesSuccess = (pdfTemplates) => {
  return {
    type: PDF_TEMPLATE_LIST_SUCCESS,
    payload: pdfTemplates,
  };
};

export const listPdfTemplatesFailure = (error) => {
  return {
    type: PDF_TEMPLATE_LIST_FAILURE,
    payload: error,
  };
};

// Render PdfTemplate (whole designer bundle)
export const renderPdfTemplate = (id) => {
  return {
    type: PDF_TEMPLATE_RENDER,
    payload: id,
  };
};

export const renderPdfTemplateSuccess = (pdfTemplate) => {
  return {
    type: PDF_TEMPLATE_RENDER_SUCCESS,
    payload: pdfTemplate,
  };
};

export const renderPdfTemplateFailure = (error) => {
  return {
    type: PDF_TEMPLATE_RENDER_FAILURE,
    payload: error,
  };
};

// Save PdfTemplate (whole design in one transaction)
export const savePdfTemplate = (pdfTemplate) => {
  return {
    type: PDF_TEMPLATE_SAVE,
    payload: pdfTemplate,
  };
};

export const savePdfTemplateSuccess = (pdfTemplate) => {
  return {
    type: PDF_TEMPLATE_SAVE_SUCCESS,
    payload: pdfTemplate,
  };
};

export const savePdfTemplateFailure = (error) => {
  return {
    type: PDF_TEMPLATE_SAVE_FAILURE,
    payload: error,
  };
};

// Delete PdfTemplate
export const deletePdfTemplate = (ids) => {
  return {
    type: PDF_TEMPLATE_DELETE,
    payload: ids,
  };
};

export const deletePdfTemplateSuccess = (ids) => {
  return {
    type: PDF_TEMPLATE_DELETE_SUCCESS,
    payload: ids,
  };
};

export const deletePdfTemplateFailure = (error) => {
  return {
    type: PDF_TEMPLATE_DELETE_FAILURE,
    payload: error,
  };
};

// Duplicate PdfTemplate
export const duplicatePdfTemplate = (id) => {
  return {
    type: PDF_TEMPLATE_DUPLICATE,
    payload: id,
  };
};

export const duplicatePdfTemplateSuccess = (pdfTemplate) => {
  return {
    type: PDF_TEMPLATE_DUPLICATE_SUCCESS,
    payload: pdfTemplate,
  };
};

export const duplicatePdfTemplateFailure = (error) => {
  return {
    type: PDF_TEMPLATE_DUPLICATE_FAILURE,
    payload: error,
  };
};

// Upload source PDF (design-over-PDF mode)
export const uploadSourcePdfTemplate = (upload) => {
  return {
    type: PDF_TEMPLATE_UPLOAD_SOURCE,
    payload: upload,
  };
};

export const uploadSourcePdfTemplateSuccess = (pdfTemplate) => {
  return {
    type: PDF_TEMPLATE_UPLOAD_SOURCE_SUCCESS,
    payload: pdfTemplate,
  };
};

export const uploadSourcePdfTemplateFailure = (error) => {
  return {
    type: PDF_TEMPLATE_UPLOAD_SOURCE_FAILURE,
    payload: error,
  };
};

// Preview PdfTemplate (server render with sample context)
export const previewPdfTemplate = (preview) => {
  return {
    type: PDF_TEMPLATE_PREVIEW,
    payload: preview,
  };
};

export const previewPdfTemplateSuccess = (preview) => {
  return {
    type: PDF_TEMPLATE_PREVIEW_SUCCESS,
    payload: preview,
  };
};

export const previewPdfTemplateFailure = (error) => {
  return {
    type: PDF_TEMPLATE_PREVIEW_FAILURE,
    payload: error,
  };
};
